import React, { useState } from 'react';
import { product } from '../data/landing';
import { legalDocuments, type LegalDocument } from '../data/legal';
import { LegalModal } from './LegalModal';
export function Footer() {
  const [activeDoc, setActiveDoc] = useState<LegalDocument | null>(null);
  return <footer className="w-full border-t border-teal/10 bg-cream py-12" data-id="element-75" data-mp="36pfvm1o1q37v">
      <div className="mx-auto max-w-readable px-6 text-center" data-id="element-76" data-mp="36nd4feb5q41k">
        <p className="font-serif text-xl font-semibold text-ink" data-id="element-77" data-mp="3ug3fzmf5elbb">
          {product.title}
        </p>
        <p className="mx-auto mt-4 max-w-readable font-sans text-base leading-relaxed text-inkSoft" data-id="element-78" data-mp="37fth3568s26">
          Este material tiene fines educativos y no sustituye el diagnóstico ni
          el tratamiento de un profesional de la salud. Consulte a su médico
          antes de cambiar su alimentación o su rutina de movimiento.
        </p>

        <nav aria-label="Información legal" className="mt-8 flex flex-col items-center justify-center gap-3 sm:flex-row sm:gap-8" data-id="element-79" data-mp="2a1jjpa3jzw2z">
          {legalDocuments.map(doc => <button key={doc.id} type="button" onClick={() => setActiveDoc(doc)} className="rounded-md font-sans text-lg font-semibold text-teal underline decoration-teal/40 decoration-2 underline-offset-4 transition-colors duration-150 ease-smooth hover:text-teal-dark hover:decoration-teal-dark focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-teal" data-id="element-80" data-mp="3lbdb8osqm1jp">
              {doc.linkLabel}
            </button>)}
        </nav>

        <p className="mt-8 font-sans text-base text-inkSoft" data-id="element-81" data-mp="hrs9hm8oyh9a">
          © {new Date().getFullYear()} {product.title}. Todos los derechos
          reservados.
        </p>
      </div>

      <LegalModal document={activeDoc} onClose={() => setActiveDoc(null)} data-id="element-82" data-mp="qsqea6qyessx" />
    </footer>;
}